import React from 'react';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/modal';
import { Button } from '@landsvirkjun/react.common';
import { FormLabel } from '@chakra-ui/form-control';

type RejectionModalProps = {
  isOpen: boolean;
  onClose: () => void;
  isUpdatingStatus: boolean;
  onApproveRequest: () => void;
};

export const FinishCostModal = ({
  isOpen,
  onClose,
  isUpdatingStatus,
  onApproveRequest,
}: RejectionModalProps): JSX.Element => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          Ertu búin að fara yfir skráninguna og tilbúin/n að senda til
          yfirferðar?
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormLabel>
            Þegar skráning hefur verið send til yfirferðar er lokað fyrir
            skráningu á vefnum. Hægt er að velja “Endurskoða kostnað” ef gera
            þarf breytingar á skráningu.
          </FormLabel>
        </ModalBody>

        <ModalFooter>
          <Button variant="warning" mr={3} onClick={onClose}>
            Hætta við
          </Button>
          <Button
            variant="primary"
            onClick={onApproveRequest}
            isLoading={isUpdatingStatus}
            loadingText="Augnablik..."
          >
            Já, senda til yfirferðar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
